import PortalUsers from "../views/schooladmin/PortalUsers";
import PortalUsersAddEdit from "../views/schooladmin/PortalUsersAddEdit";

export default [
	{
		path: "/schooladmin/portal_users",
		meta: { requiresPortalAdmin: true },
		components: {
			content: PortalUsers
		}
	},
	{
		path: "/schooladmin/portal_users/new",
		meta: { requiresPortalAdmin: true },
		components: {
			content: PortalUsersAddEdit
		}
	},
	{
		path: "/schooladmin/portal_users/update/:id",
		meta: { requiresPortalAdmin: true },
		components: {
			content: PortalUsersAddEdit
		},
		props: {
			content: true
		}
	}
];
